<!--  经销商资料管理维护（代办处） -->
<template>
  <div>
    <app-breadcrumb />
    <div class="page-container withdraw-manage">
      <el-form size="mini" :inline="true" :model="listQuery" >
        <el-row>
          <!-- 经销商编号 -->
          <el-form-item :label="$t('miMember.memberNo')">
            <el-input v-model.trim="listQuery.memberNo" clearable :placeholder="$t('')" />
          </el-form-item>
          <!-- 经销商姓名 -->
          <el-form-item :label="$t('miMember.name')">
            <el-input v-model.trim="listQuery.name" clearable :placeholder="$t('')" />
          </el-form-item>
          <!--荣衔-->
            <el-form-item :label="$t('mi.honourLevel') + ':'">
              <el-select v-model="listQuery.newCardType" style="width: 100%">
                <el-option value="" />
                <el-option v-for="i in mimemberhonourLevel" :key="i.code" :label="$t(i.title)" :value="i.code" />
              </el-select>
            </el-form-item>
          <!--级别-->
          <el-form-item :label="$t('commond.levelType') + ':'">
            <el-select v-model="listQuery.levelType" style="width: 100%">
              <el-option value="" />
              <el-option v-for="i in mimemberlevel" :key="i.code" :label="$t(i.title)" :value="i.code" />
            </el-select>
          </el-form-item>
          <!-- 加入期数 -->
          <el-form-item :label="$t('miAgent.startWeek')">
            <el-select v-model="listQuery.fromWeek" clearable style="width:105px;">
              <el-option v-for="i in wWeekList" :key="i.id" :label="i.wWeek" :value="i.wWeek" />
            </el-select>
            <span style="padding: 0 5px;">-</span>
            <el-select v-model="listQuery.toWeek" clearable style="width:105px;">
              <el-option v-for="i in wWeekList" :key="i.id" :label="i.wWeek" :value="i.wWeek" />
            </el-select>
          </el-form-item>
          <el-button :loading="btnLoading" size="small" type="primary" icon="el-icon-search" @click="handleFilter">{{ $t('function.menu.search') }}</el-button>
        </el-row>
      </el-form >
      <el-table
          v-loading="tableLoading"
          :data="list"
          border
          fit
          size="mini"
          stripe
          style="width: 100%"
      >
        <el-table-column :label="$t('sysOperationLog.moduleName')" width="80" align="center">
          <template v-slot="{row}">
            <el-button :loading="btnLoading" circle size="mini" icon="el-icon-search" :title="$t('button.view')" @click="viewTableBtn(row)" />
          </template>
        </el-table-column>
        <!-- 代办处编号 -->
        <el-table-column :label="$t('miAgent.agentNo')" prop="agentNo" align="center"/>
        <!-- 经销商编号 -->
        <el-table-column :label="$t('miMember.memberNo')" prop="memberNo" align="center"/>
        <!-- 经销商名称 -->
        <el-table-column :label="$t('miMember.name')" prop="name" align="center"/>
        <!-- 级别 -->
        <el-table-column :label="$t('commond.levelType')" prop="levelType" align="center">
           <template v-slot="{row}">
            {{$lt(initDict.mimemberlevel,row.levelType)}}
          </template>
        </el-table-column>
        <!-- 积分 -->
        <el-table-column v-if="companyCode!== 'BD'" :label="$t('busi.direct.sale_points')" prop="regPv" align="center"/>
        <!-- 推荐人编号 -->
        <el-table-column :label="$t('mi.sellerNo')" prop="recommendNo" align="center"/>
        <!-- 推荐人姓名 -->
        <el-table-column :label="$t('csWarrantyCard.sellerName')" prop="recommendName" align="center"/>
        <!-- 安置人编号 -->
        <el-table-column v-if="companyCode!== 'BD'" :label="$t('mi.servicerNo')" prop="linkNo" align="center"/>
        <!-- 加入期数 -->
        <el-table-column :label="$t('miAgent.startWeek')" prop="chinaWWeek" align="center"/>
      </el-table>
      <pagination
          v-show="total>0"
          :total="total"
          :page.sync="listQuery.page"
          :limit.sync="listQuery.limit"
          @pagination="getList"
      />
    </div>
  </div>
</template>

<script>
import { getMembers } from '@/api/agent'
import { mapGetters } from "vuex"
import Pagination from "@/components/Pagination"
export default {
  name: 'DealerPro',
  components: { Pagination },
  data() {
    return {
      btnLoading: false,
      list: [],
      wWeekList: [],
      tableLoading: false,
      total: 0,
      listQuery: {
        page: 1,
        limit: 10
      },
      initDict: {
        status: 'fi_ac_appl_status_cn',
        mimemberhonourLevel: 'cn.mimember.cardtype',    //荣衔
        mimemberlevel: 'cn.member.level'    //级别
      }
    }
  },
  computed: {
    ...mapGetters([
      'userCode',
      'companyCode'
    ]),
    statusList() {
      return this.$ll(this.initDict.status)
    },
    mimemberhonourLevel() {
      return this.$ll(this.initDict.mimemberhonourLevel)
    },
    mimemberlevel() {
      return this.$ll(this.initDict.mimemberlevel)
    },
  },
  mounted() {
    this.wWeekList = JSON.parse(sessionStorage.getItem('wWeekLocalList'))
  },
  created() {
  },
  methods: {
    getList() {
      this.tableLoading = true
      this.btnLoading = true
      getMembers({ ...this.listQuery }).then(res => {
        this.list = res.data.records
        this.total = +res.data.total || 0
        this.getBalance()
        this.tableLoading = false
        this.btnLoading = false
      }).catch(err => {
        console.warn(err)
        this.tableLoading = false
        this.btnLoading = false
      })
    },
    handleFilter() {
      this.listQuery.page = 1
      this.getList()
    },
    viewTableBtn(row) {
      this.$router.push({name: 'DealerView', params:{ id: row.id }})
    }
  }
}
</script>
